import React from "react";
import { useTranslation } from "react-i18next";
import meet from "../../assets/images/meeting3.jpeg";

export default function WhiteLableSolutionComponent() {
    const { t } = useTranslation();

    return (
        <div
            className="tab-content-details-wrapper"
            style={{
                backgroundImage: `url(${meet})`,
                display: "100%",
                height: "100%",
                width: "100%",
            }}
        >
            <div className="tab-label">
                {/* <div>{t("Enterprise")}</div> */}
                <div>Easy branding &amp; customization</div>
            </div>
        </div>
    );
}
